module.exports = __webpack_public_path__ + "img/zm-p2@2x.5a4a50d9.png";